import { useMutation } from "@tanstack/react-query";
import { isAllBusiness, useRootAPI } from "@/api";
import { customToast } from "@/utils/customToast";

export function useInviteFoodicsAccounts() {
  const api = useRootAPI();

  return useMutation({
    mutationFn: async (args: {
      businessId: string;
      accountIds: string[];
      userIsDemo?: boolean;
    }) => {
      if (args.userIsDemo) {
        return;
      }

      if (isAllBusiness(args.businessId)) {
        throw new Error("cannot invite Foodics accounts in ALL BUSINESSES context");
      }
      await api.postInviteFoodicsAccounts({
        business_id: args.businessId,
        InviteFoodicsAccountsRequest: {
          ext_ids: args.accountIds,
        },
      });
    },
    onSuccess: () => {
      customToast("Login instructions sent by email", "success", "bottom");
    },
  });
}
